import { Link } from "react-router-dom";
import { Mail, ArrowLeftRight } from "lucide-react";
import { Logo } from "./Navbar";

const NAV = [
  { to: "/solutions", label: "Solutions" },
  { to: "/products", label: "Products" },
  { to: "/projects", label: "Projects" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer className="relative bg-[#0B132B] text-white grain-overlay" data-testid="main-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <Logo light />
            <p className="mt-5 font-display text-lg font-semibold text-white/90">
              Source in Colombia. Build in the Caribbean.
            </p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-white/55">
              Real Estate Intelligence | Colombian Sourcing | Procurement | Export | Logistics
            </p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#14B8A6]">Navigation</p>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    data-testid={`footer-${n.label.toLowerCase()}-link`}
                    className="text-sm text-white/70 transition-colors hover:text-white"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#14B8A6]">Contact</p>
            <a
              href="mailto:contactbuycaribbean@gmail.com"
              data-testid="footer-email-link"
              className="mt-5 flex items-center gap-2 text-sm text-white/80 transition-colors hover:text-white"
            >
              <Mail className="h-4 w-4 text-[#14B8A6]" />
              contactbuycaribbean@gmail.com
            </a>
            <p className="mt-5 flex items-center gap-2 text-sm text-white/70" data-testid="footer-geography">
              <ArrowLeftRight className="h-4 w-4 text-[#14B8A6]" />
              Colombia ↔ Caribbean
            </p>
          </div>
        </div>
        <div className="mt-16 overflow-hidden">
          <p className="outline-word text-[12vw] lg:text-[9rem]" aria-hidden="true">
            BUY CARIBBEAN
          </p>
        </div>
        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-7 sm:flex-row sm:items-center">
          <p className="text-xs text-white/45">© 2026 BUY CARIBBEAN. All rights reserved.</p>
          <div className="flex gap-6 text-xs text-white/45">
            <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-white">
              Privacy Policy
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className="transition-colors hover:text-white">
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
